module.exports = __webpack_public_path__ + "static/media/SRM_Logo.bc2e9965.png";